export default "__VITE_ASSET__BjblvlTL__"